import type { QueryClient } from '@tanstack/react-query';

/** Prefix for all scooter list queries — use with invalidateQueries to refresh every slice. */
export const SCOOTERS_ROOT = ['scooters'] as const;

export function scootersManagementTableKey(orgId: string | undefined) {
  return ['scooters', 'managementTable', orgId] as const;
}

export function scootersContractsShellKey(orgId: string | undefined) {
  return ['scooters', 'contractsShell', orgId] as const;
}

export function scootersSelectorKey(orgId: string | undefined) {
  return ['scooters', 'selector', orgId] as const;
}

export function scootersBookingRequestsKey(orgId: string | undefined) {
  return ['scooters', 'bookingRequests', orgId] as const;
}

export function scootersBookingDetailKey(orgId: string | undefined) {
  return ['scooters', 'bookingDetail', orgId] as const;
}

export function scootersContractsMobileKey(orgId: string | undefined) {
  return ['scooters', 'contractsMobile', orgId] as const;
}

export function scootersMaintenanceMobileKey(orgId: string | undefined) {
  return ['scooters', 'maintenanceMobile', orgId] as const;
}

export function scootersMobileListKey(orgId: string | undefined) {
  return ['scooters', 'mobileList', orgId] as const;
}

export function scootersUserActionsKey(orgId: string | undefined) {
  return ['scooters', 'userActions', orgId] as const;
}

export function scootersSidebarPrefetchKey(orgId: string | undefined) {
  return ['scooters', 'sidebarPrefetch', orgId] as const;
}

/** Walk every scooter list cache and return status for an id (for Kanban / contract UI). */
export function getScooterStatusFromQueryCaches(qc: QueryClient, scooterId: string): string | undefined {
  const entries = qc.getQueriesData({ queryKey: SCOOTERS_ROOT });
  for (const [, data] of entries) {
    const items = (data as { items?: { id: string; status?: string }[] })?.items;
    if (!Array.isArray(items)) continue;
    const s = items.find((x) => x.id === scooterId);
    if (s?.status) return s.status;
  }
  return undefined;
}

export function snapshotAllScooterQueries(qc: QueryClient) {
  return qc.getQueriesData({ queryKey: SCOOTERS_ROOT });
}

export function restoreScooterQueries(
  qc: QueryClient,
  snapshot: ReturnType<typeof snapshotAllScooterQueries>
) {
  snapshot.forEach(([queryKey, data]) => {
    qc.setQueryData(queryKey, data);
  });
}
